import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Spin } from "antd";

// Common Routes
const UserPageContainer = lazy(() => import("../layouts/UserPageContainer"));
const AdminPageContainer = lazy(() => import("../layouts/AdminPageContainer"));
const Home = lazy(() => import("../views/appViews/Home"));
const Test = lazy(() => import("../views/appViews/Test"));
const NotFound = lazy(() => import("../views/appViews/NotFound"));
const About = lazy(() => import("../views/appViews/About"))

// Auth Routes
const Register = lazy(() => import("../views/authViews/Register"));
const Login = lazy(() => import("../views/authViews/Login"));
const AdminLogin = lazy(() => import("../views/authViews/AdminLogin"));

// User Routes
const Dashboard = lazy(() => import("../views/appViews/user/dashboard"));
const UpdateProfile = lazy(() => import("../views/appViews/user/updateProfile"));
const TransferApplication = lazy(() => import("../views/appViews/user/transferApplication"));
const MyApplications = lazy(() => import("../views/appViews/user/myApplications"));

// Admin Routes
const UserViewProfile = lazy(() =>import("../views/appViews/admin/userViewProfile"));
const AdminDashboard = lazy(() => import("../views/appViews/admin/adminDashboard"));
const CadreManagement = lazy(() => import("../views/appViews/admin/cadreManagement"));
const UserManagement = lazy(() => import("../views/appViews/admin/userManagement"));;
const AdminManagement = lazy(() =>import("../views/appViews/admin/adminManagement"));
const TransferWindow = lazy(() => import("../views/appViews/admin/transferWindow"));
const TransferApplications =lazy(() => import ("../views/appViews/admin/transferApplication"));
const NotAppliedUsers =lazy(() => import ("../views/appViews/admin/notAppliedUsers"));

const userRoutes = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/dashboard/update-profile", element: <UpdateProfile /> },
  {
    path: "/dashboard/transfer-management/transfer-window",
    element: <TransferWindow />,
  },
  {
    path: "/dashboard/transfer-management/transfer-applications",
    element: <TransferApplication />,
  },
  {
    path: "/dashboard/transfer-management/my-applications",
    element: <MyApplications />,
  },
];

const adminRoutes = [
  { path: "/admin_dashboard", element: <AdminDashboard /> },
  {
    path: "/admin_dashboard/transfer-management/transfer-window",
    element: <TransferWindow />,
  },
  {
    path: "/admin_dashboard/transfer-management/transfer-applications",
    element: <TransferApplications />,
  },
  {
    path: "/admin_dashboard/transfer-management/notApllied-user",
    element: <NotAppliedUsers />,
  },
  { path: "/admin_dashboard/admin-management", element: <AdminManagement /> },
  { path: "/admin_dashboard/user-management", element: <UserManagement /> },
  { path: "/admin_dashboard/cadre-management", element: <CadreManagement /> },
  { path: "/admin_dashboard/view-profile/:id", element: <UserViewProfile /> },
];

const RoutesPage = () => (
  <Router>
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <Spin
            size="large"
            tip="Loading..."
            style={{ fontSize: "24px", transform: "scale(2)" }}
          />
        </div>
      }
    >
      <Routes>
        <Route element={<UserPageContainer />}>
          {userRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Route>

        <Route element={<AdminPageContainer />}>
          {adminRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Route>

        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin_login" element={<AdminLogin />} />
        <Route path="register" element={<Register />} />
        <Route path="/test" element={<Test />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  </Router>
);

export default RoutesPage;
